let YourFamily = Backbone.Model.extend(
    {
        defaults:
            {
                inRelationship: false,
                timeWithPartner: appConfig.family.timeWithPartner.defaultValue,
                hasDependentChildren: false,
                childActivities: null,
            },

        initialize: function () {
            let loadChildActivity = new ChildActivityList(unpackList(this.getChildActivities(), CreateChildActivity));
            let childActivity = new ChildActivityList();

            _.each(appConfig.family.childActivityOptions, function (childActivityOption) {
                childActivity.add(new ChildActivity().createFromConfig(childActivityOption).loadIn(loadChildActivity))
            });
            this.set('childActivities', childActivity);
        },

        isInRelationship: function () {
            return this.get('inRelationship');
        },

        setIsInRelationship: function (status) {
            this.set('inRelationship', status);
        },

        getTimeWithPartner: function () {
            return this.get('timeWithPartner');
        },

        setTimeWithPartner: function (time) {
            this.set('timeWithPartner', parseInt(time));
        },

        hasDependentChildren: function () {
            return this.get('hasDependentChildren');
        },

        setHasDependentChildren: function (status) {
            this.set('hasDependentChildren', status);
        },


        getChildActivities: function () {
            return this.get('childActivities');
        },

        averageUtilisedHours: function () {
            let hours = 0;
            if (this.isInRelationship()) {
                hours += this.getTimeWithPartner()
            }
            if (this.hasDependentChildren()) {

                this.getChildActivities().each(function (childActivity) {
                    if (childActivity.isSelected()) {
                        let activityAverageHours = (childActivity.getDaysAWeek() * childActivity.getAfterWorkHours() / 7.0);
                        appLogAttr('childActivity->' + childActivity.getName(), 'activityAverageHours', activityAverageHours);
                        hours += activityAverageHours;
                    }
                });

            }

            return hours;
        }
    }
);
